<!-- Progreso y Navegación -->
<div class="z-10 hidden lg:flex bottom-4 p-4 custom-navigation">
    <div class="flex items-center justify-center mx-auto p-2 rounded-full shadow-lg bg-primary">
        <div class="flex items-center justify-center mx-2.5 font-medium leading-5 text-on-primary">
            <span>{{currentStep + 1}}</span>
            <span class="mx-0.5 text-hint">/</span>
            <span>{{pasosTotal}}</span>
        </div>
        <button
            class="flex-0 btn-nav"
            mat-flat-button
            [color]="'primary'"
            (click)="goToNext()"
            [disabled]="disableNext || disableSaveBtn || isLoading === 'go'">
            <span
                class="ml-1"
                *ngIf="isLoading !== 'go'">{{checkStepCurrent() ? "Guardar" : "Siguiente"}}
            </span>
            <mat-spinner
                class="ml-1 customIconSize"
                *ngIf="isLoading === 'go'">
            </mat-spinner>
            <mat-icon
                class="ml-2"
                [svgIcon]="'heroicons_outline:arrow-narrow-right'" *ngIf="!checkStepCurrent()"></mat-icon>
        </button>
    </div>
</div>
